import { createNode } from '@glueapp/graph-types';

export const Floor = createNode({
    id: 'Floor',
    name: 'Floor',
    description: 'Rounds the number down to the next lowest full number. Examples: 0.3 becomes 0, -2,2 becomes -3 and 3.8 becomes 3',
    aiDescription:
        'Rounds a number down to the nearest integer (floor). Connect a value to the "Number" input port; the "Next Lowest Number" output port provides the result.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
    },
    outPorts: {
        'Next Lowest Number': { kind: 'number' },
    },
    execute: function (input) {
        const inputNumber = input.inPorts.Number;
        return { output: { 'Next Lowest Number': Math.floor(inputNumber) } };
    },
});
